
import Router from './routes.jsx';


export default function App() {
  
  return(     
    <Router/>
  );
}
